export var BILLING_TITLE_GENERATE = "Generar Cobros";
export var BILLING_TYPE_OPTIONS = [
    {
        id: "GENERAL",
        name: "Cobranza General",
        value: "GENERAL",
        description: "Proceso mensual estándar con las reglas configuradas por defecto.",
    },
    {
        id: "NEW",
        name: "Nuevos cobros",
        value: "NEW",
        description: "Genera cobros únicamente para pólizas nuevas, aún no facturadas.",
    },
    {
        id: "REBILLING",
        name: "Recobranza únicamente",
        value: "REBILLING",
        description: "Reintenta el cobro de pólizas con pagos pendientes o rechazados, sin generar cobros nuevos.",
    },
];
export var BILLING_NO_PRODUCTS_SELECTED_MESSAGE = "No hay proyectos seleccionados.";
export var BILLING_GENERIC_ERROR_MESSAGE = "Error al generar el cobro.";
/**
 * Traduce codigos de error puntuales que devuelve el backend al generar la
 * cobranza a un mensaje entendible para el usuario. Si el codigo no esta
 * mapeado, se usa BILLING_GENERIC_ERROR_MESSAGE como fallback.
 */
export var BILLING_COLLECTION_ERROR_MESSAGES = {
    ACTIVE_BILLING_COLLECTION_JOB_EXISTS: "Ya existe un proceso de cobranza. Espera a que finalice para generar uno nuevo.",
};
export var BILLING_PRODUCTS_PAGE_SIZE = 8;
export var BILLING_PRODUCTS_FETCH_LIMIT = 500;
export var BILLING_PRESET_PANEL_TITLE = "Tipo de cobranza";
export var BILLING_PRESET_PANEL_SUBTITLE = "Precarga las reglas de abajo. Podés editarlas igual.";
export var BILLING_RULES_PANEL_TITLE = "Período y reglas de facturación";
export var BILLING_RULES_SECTION_LABEL = "Reglas adicionales de este cliente";
export var BILLING_MONTH_LABEL = "Mes de cobranza";
export var BILLING_MAX_PERIODS_LABEL = "Períodos máximos a cobrar";
export var BILLING_CANCEL_AFTER_LABEL = "Cancelar la póliza después de (meses)";
export var BILLING_MAX_INVOICES_LABEL = "No. máximo de facturas por póliza";
export var BILLING_FILE_PER_PRODUCT_LABEL = "Separar archivos por producto";
export var BILLING_NO_CANCEL_EXPIRED_POLICY_LABEL = "No cancelar póliza con pagos vencidos";
export var BILLING_NO_EXPIRED_POLICY_AGE_LABEL = "No expirar pólizas por edad";
export var BILLING_CHECKBOX_OPTIONS = [
    {
        key: "filePerProduct",
        field: "filePerProduct",
        label: BILLING_FILE_PER_PRODUCT_LABEL,
    },
    {
        key: "noCancelPolicy",
        field: "noCancelExpiredPolicy",
        label: BILLING_NO_CANCEL_EXPIRED_POLICY_LABEL,
    },
    {
        key: "noExpiredPolicyAge",
        field: "noExpiredPolicyAge",
        label: BILLING_NO_EXPIRED_POLICY_AGE_LABEL,
    },
];
export var BILLING_PRODUCTS_PANEL_TITLE = "Productos a facturar";
export var BILLING_PRODUCTS_SEARCH_PLACEHOLDER = "Buscar por nombre, código o aseguradora…";
export var BILLING_SELECT_ALL_LABEL = "Marcar todos";
export var BILLING_UNSELECT_ALL_LABEL = "Quitar todos";
export var BILLING_LEGACY_PRODUCT_LABEL = "Legacy";
export var BILLING_CANCEL_BUTTON_LABEL = "Cancelar";
export var BILLING_SUBMIT_BUTTON_LABEL = "Generar";
export var BILLING_RESET_DEFAULTS_LABEL = "Restaurar valores predeterminados";
